/**
 * Conversation Summary Service — BUB-128
 */

import api from "../../../shared/api.jsx";

/**
 * @param {string} leadId
 * @returns {Promise<Object>}
 */
export const getConversationSummary = async (leadId) => {
  const response = await api.get(`/leads/${leadId}/conversation-summary`);
  return response.data;
};

/**
 * @param {string} leadId
 * @param {{ summaryMode?: 'executive' | 'structured' }} [options]
 * @returns {Promise<Object>}
 */
export const refreshConversationSummary = async (leadId, options = {}) => {
  const body = {};
  if (options.summaryMode === "structured") {
    body.summaryMode = "structured";
  }
  const response = await api.post(
    `/leads/${leadId}/conversation-summary/refresh`,
    body
  );
  return response.data;
};
